import { Box, Link, Typography } from '@mui/material'
import { Browser } from '../lib/browser'

interface UnsupportedBrowserProps {
  browser: Browser
}

export default function UnsupportedBrowser({
  browser,
}: UnsupportedBrowserProps) {
  const currentUrl = window.location.href

  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant='h5' gutterBottom>
        <b>Bad News</b>: the {browser.name} browser is not supported by our
        system.
      </Typography>
      <Typography variant='body1'>
        <Box
          component='span'
          sx={{ color: 'primary.main', fontWeight: 'bold' }}
        >
          The Good News:
        </Box>
        <br />
        You can long-press{' '}
        <Link
          href={currentUrl}
          target='_blank'
          rel='noopener'
          sx={{ fontWeight: 'bold' }}
        >
          this link
        </Link>{' '}
        and select &quot;Open Link&quot; to use a real browser.
        <br />
        Or Tap the ⋯ icon on the top right, then select &quot;Open in
        Browser&quot; to continue.
      </Typography>
    </Box>
  )
}
